// React
import React from "react";
// Redux
//import { Dispatch } from 'redux';
import { useSelector } from "react-redux";
// Css
import { Card, Col, Container, Row } from "react-bootstrap";
import { Header } from "../Partials/Header";
import { Footer } from "../Partials/Footer";
import "./main.css";

export const Main = () => {
	const { connected } = useSelector((state: any) => state.user);
	//const dispatch: Dispatch<any> = useDispatch();

	return (
		<React.Fragment>
			<Header />
			{connected ? (
				<div className={"main"}>
					<Container className='projectsContainer'>
						<div className='projects'>
							<Row style={{ width: "100%" }}>
								<Col sm={6} md={4}>
									<Card
										className='project pointer'
										onClick={() => {
											document.location.href = "https://bo.os.timescope.com/";
										}}
									>
										<img
											className='project-img-top'
											src='/headsetVR.jpg'
											alt={"Image d'un casque VR"}
										/>
										<div className='card-body'>
											<h5 className='project-title'>TSAdventure</h5>
											<p className='project-text'>
												Dashboard pour les produits TSAdventures.
												<br />
												bo.os.timescope.com
											</p>
											<div className='project-link'>
												<div>Dashboard</div>
												<img
													src='https://assets-global.website-files.com/60b8cabe0de4ed56211a6825/60b8cabe0de4edc8be1a68a2_arrow-right(48x48)%402x.svg'
													loading='lazy'
													alt='Flèche vers la droite'
													height='12'
													className='image-22'
												/>
											</div>
										</div>
									</Card>
								</Col>
								<Col sm={6} md={4}>
									<Card
										className='project pointer'
										onClick={() => {
											document.location.href = "https://bo.capture.timescope.com/";
										}}
									>
										<img
											className='project-img-top'
											src='/photobooth.jpg'
											alt={"Image d'un appareil photo"}
										/>
										<div className='card-body'>
											<h5 className='project-title'>TSCapture</h5>
											<p className='project-text'>
												Dashboard pour les produits TSCapture.
												<br />
												bo.capture.timescope.com
											</p>
											<div className='project-link'>
												<div>Dashboard</div>
												<img
													src='https://assets-global.website-files.com/60b8cabe0de4ed56211a6825/60b8cabe0de4edc8be1a68a2_arrow-right(48x48)%402x.svg'
													loading='lazy'
													alt='Flèche vers la droite'
													height='12'
													className='image-22'
												/>
											</div>
										</div>
									</Card>
								</Col>
								<Col sm={6} md={4}>
									<Card className='projectDisabled pointer bg-light mb-3'>
										<img
											className='project-img-top'
											src='/gsm.jpg'
											alt={"Image d'un portable"}
										/>
										<div className='card-body'>
											<h5 className='project-title'>TSApp</h5>
											<p className='project-text'>
												Dashboard pour les applications de voyage dans le temps.
												<br />À venir !
											</p>
											<div
												className='project-link'
												style={{ color: "#576177" }}
											>
												<div>Dashboard</div>
												<img
													src='https://assets-global.website-files.com/60b8cabe0de4ed56211a6825/60b8cabe0de4edc8be1a68a2_arrow-right(48x48)%402x.svg'
													loading='lazy'
													alt='Flèche vers la droite'
													height='12'
													className='image-22'
												/>
											</div>
										</div>
									</Card>
								</Col>
							</Row>
						</div>
					</Container>
				</div>
			) : (
				<div className={"main"}>Hello</div>
			)}
			<Footer />
		</React.Fragment>
	);
};
